import { firebaseFunctions } from 'contexts/FirebaseContext';

export const getVirgilJwt = firebaseFunctions.httpsCallable('getVirgilJwt');
export const validateAdmin = firebaseFunctions.httpsCallable('validateAdmin');
